import { useState, useEffect } from 'react';
import { Container, Grid, Typography, Button }from '@material-ui/core';
import { Locations as LocationService, Companies } from '../api/api';
import { Location, Company } from '../models/location.interface';
import { LocationsGrid } from '../components/Locations/LocationsGrid';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import AddLocationDialog from '../components/Locations/AddLocationDialog';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    container: {
      padding: 20,
    },
    pageTitle: {
      color: theme.palette.primary.dark,
      fontWeight: 'bold',
    },
    gridSpacer: {
      minHeight: '12px',
    },
  }),
);

export const Locations = () => {
  const classes = useStyles(); 
  const [ open, setOpen ] = useState<boolean>(false);
  const [ locationList, setLocationList ] = useState<Location[]>([]);
  const [ companyList, setCompanyList ] = useState<Company[]>([]);

  useEffect(() => {
    loadCompanyList();
    loadAllLocations();
  },[])

  const loadAllLocations = () => {
    LocationService.getAllLocations()
    .then((locs) => {
      setLocationList(locs.sort((a,b) => (a.name > b.name) ? 1 : -1))
    }).catch(() => {
      setLocationList([])
    })
  }

  const loadCompanyList = () => {
    Companies.getAllCompanies()
      .then((companies) => {
        setCompanyList(companies.sort((a,b) => (a.name > b.name) ? 1 : -1))
      })
      .catch((e) => {
        setCompanyList([])
      })
  }

  return (
    <Container 
      component="main" 
      className={classes.container}
    >
      <Grid container justifyContent="space-between">
        <Grid item>
          <Typography className={classes.pageTitle} variant="h5">
            Locations
          </Typography>
        </Grid>
        <Grid item>
          <Button 
            variant="contained"
            color="primary"
            size="small" 
            startIcon={<AddLocationIcon/>}
            onClick={() => setOpen(true)}
          >
            Add Location
          </Button> 
        </Grid>
      </Grid>
      <Grid container className={classes.gridSpacer} />
      <Grid container>
        <LocationsGrid
          locationList={locationList}
          loadAllLocations={loadAllLocations}
          companyList={companyList}
        />
      </Grid>
      <AddLocationDialog 
        open= {open}
        onClose={() => setOpen(false)} 
        loadAllLocations={loadAllLocations}
        companyList={companyList}
      /> 
    </Container>
  );
};

export default Locations;
